module.exports = __webpack_public_path__ + "media/images/arrows/twisted/seledyn-left-3000752b95405fae3fdd66504ef887e1.svg";